var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 29,
  viewBox: "0 0 26 29",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.21875 0H18.6208L18.7365 0.00402275C22.7351 0.0814607 26.001 3.38112 26.001 7.35861V17.4416C26.001 19.3162 25.3017 21.0702 24.022 22.4339L26.001 24.3718V28.999L18.4199 21.5599L20.7531 19.2257L21.6695 20.1278C22.3251 19.3866 22.6945 18.4312 22.6945 17.4416V7.35962C22.6945 5.10889 20.8464 3.27753 18.5752 3.27753H7.42679C6.47079 3.27753 5.53812 3.61142 4.80132 4.21685C4.32535 4.60806 3.93665 5.11291 3.67786 5.6771L3.27292 6.55909L0.76416 4.07203L1.03107 3.6245C1.4289 2.95773 1.92923 2.35733 2.51786 1.84342C3.64538 0.856846 5.05808 0.231308 6.54081 0.0533014",
  fill: "#025E73"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.42683 24.802C3.33182 24.802 0 21.5013 0 17.4434V6.8877L3.30645 10.1622V17.4434C3.30645 19.6941 5.15453 21.5255 7.42582 21.5255H14.7877L18.0941 24.802H7.42683Z",
  fill: "#D96941"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8132 9.0791H8.06018V18.6281H11.8132V9.0791Z",
  fill: "#D96941"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9388 6.45117H14.1868V18.3525H17.9388V6.45117Z",
  fill: "#D96941"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 29,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo.1b646667.svg";
export { ForwardRef as ReactComponent };